export default {
	typeOptions: [
		{ id: "meeting", label: "Meeting" },
		{ id: "call", label: "Call" },
		{ id: "email", label: "Email" },
		{ id: "note", label: "Note" }
	],
	filters: [
		{ id: "all", label: "All" },
		{ id: "meeting", label: "Meetings" },
		{ id: "email", label: "Emails" },
		{ id: "call", label: "Calls" },
		{ id: "note", label: "Notes" }
	],
	typeLabels: {
		meeting: "Meet",
		email: "Email",
		call: "Call",
		note: "Note"
	},
	statusLabels: {
		pending: "Summarizing...",
		processing: "Processing...",
		failed: "Summary failed"
	}
};
